/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from './defs.defs'

const $nsid = 'us.edriffles.radlib.moderation.getListMuteAttestation'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  list: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  listUriHash: /*#__PURE__*/ l.string({ maxLength: 64 }),
  nonce: /*#__PURE__*/ l.string({ minLength: 16, maxLength: 128 }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  attestation: /*#__PURE__*/ l.ref<ModerationDefs.Attestation>(
    (() => ModerationDefs.attestation) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns a provider-signed private-list-mute claim. Fork-specific; not an AT Protocol standard. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
